import React, { ReactNode } from 'react';
import {
    BannerBar,
    BannerContainerStyle,
    BannerContent
} from './HBBanner.styles';

export interface IBannerTheme {
    barColor?: string;
    backgroundColor?: string;
    textAlignment?: 'left' | 'center' | 'right';
    fontSize?: string;
    boxShadow?: string;
    minHeight?: string;
}
export interface Props {
    children: ReactNode | ReactNode[];
    /** Applies `position: sticky` so the banner stays fixed during scroll. */
    sticky?: boolean;
    /** CSS `top` offset in pixels, used with `sticky` to control fixed position. */
    top?: number;
    /** CSS padding value applied to the banner's content area. */
    contentPadding?: string;
    margin?: string;
    /** Overrides the banner's visual styling including bar color, background, text alignment, and dimensions. */
    customTheme?: IBannerTheme;
    className?: string;
    testId?: string;
    zIndex?: number;
}

/** @deprecated use the specialized banner components instead. see them on our [Storybook](https://honeybook.github.io/hbui/?path=/story/hbbanner--info-banners) */
const HBBanner = ({
    children,
    sticky,
    top,
    contentPadding,
    margin,
    customTheme,
    className,
    testId,
    zIndex
}: Props) => {
    let textAlignment;
    if (customTheme?.textAlignment) {
        textAlignment = customTheme.textAlignment
            .replace('left', 'flex-start')
            .replace('right', 'flex-end');
    }
    return (
        <BannerContainerStyle
            top={top}
            sticky={sticky}
            margin={margin}
            minHeight={customTheme?.minHeight}
            boxShadow={customTheme?.boxShadow}
            className={className}
            background={customTheme?.backgroundColor}
            data-testid={testId}
            zIndex={zIndex}
        >
            <BannerBar color={customTheme?.barColor} />
            <BannerContent
                fontSize={customTheme?.fontSize}
                textAlignment={textAlignment}
                contentPadding={contentPadding}
            >
                {children}
            </BannerContent>
        </BannerContainerStyle>
    );
};

export default HBBanner;
